import { Component, OnInit, OnChanges } from '@angular/core';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { GLOBAL } from 'src/app/services/global';
@Component({
  selector: 'page-formulario45',
  templateUrl: './formulario45.component.html',
  styleUrls: ['./formulario45.component.css']
})
export class Formulario45Component implements OnInit {
  public nombreMuni = GLOBAL.nombreMuni;
  public region = GLOBAL.region;
  public propiedad;
  public propietarios;
  public permiso_notariado;
  public arquitectos;
  public loteo_const;
  public mod_parcial;
  public caract_proy_mod;
  public caract_solicitud;
  public caract_anteproy_loteo;
  public lotes_enajenar;
  public caract_sol;
  public tipo_solicitud_def_urb;
  public caract_proy_garantia;

  //contadores

  public sup_proy_total = 0;
  public cant = 0;
  public sup_porcentajes = 0;
 
  

   pages = [1,2,3];

  constructor() {

  


  }

   ngOnInit(){

   }

   ngAfterContentChecked(){


    this.ngAfterContentInit();
    
  }

  ngDoCheck(){
    this.sup_proy_total = 0;

    //LOTES ENAJENAR
    if(JSON.parse(localStorage.getItem("lotes_enajenar"))){
      if (JSON.parse(localStorage.getItem("lotes_enajenar")).length > 0){
        this.lotes_enajenar = JSON.parse(localStorage.getItem("lotes_enajenar"))
      }else{ 
      localStorage.setItem("lotes_enajenar", JSON.stringify([]))
        this.lotes_enajenar = [{lotes_enajenar:'',num_lotes:'',sup_lotes_enajenar:'', hoja_anexa:''}]
      }
    }


    for (let i = 0; i < this.lotes_enajenar.length; i++) {
      
      this.sup_proy_total = this.sup_proy_total + parseInt(this.lotes_enajenar[i].sup_lotes_enajenar);
    }
  }

   ngAfterContentInit() {
    
  
    //PROPIEDAD
    if(JSON.parse(localStorage.getItem("propiedad"))){
      if (JSON.parse(localStorage.getItem("propiedad")).length > 0){ 
        this.propiedad = JSON.parse(localStorage.getItem("propiedad"));
      }else{
       localStorage.setItem("propiedad", JSON.stringify([]))
        this.propiedad = [{rol: '', id_direcc: '', folio: '', calle: '', calle_num: 0, direccion_completa:'', direc_complemento:'', direc_compl_num:'', loteo:'', manzana:'', plano:'', recordId:''}]
      }
    }

    //PROPIETARIOS
    if(JSON.parse(localStorage.getItem("propietarios"))){
      if (JSON.parse(localStorage.getItem("propietarios")).length > 0){
        this.propietarios = JSON.parse(localStorage.getItem("propietarios"));
     }else{
        localStorage.setItem("propietarios", JSON.stringify([]))
        this.propietarios = [{rut: '', nombre: '',  apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '',  comuna: '', fono: '', fax: '', mail: '',recordId: ''}]
     }
    }

     //PERMISO NOTARIADO
    if(JSON.parse(localStorage.getItem("permiso_notariado"))){
      if(JSON.parse(localStorage.getItem("permiso_notariado")).length > 0){
        this.permiso_notariado = JSON.parse(localStorage.getItem("permiso_notariado"));
      }else{
       localStorage.setItem("permiso_notariado", JSON.stringify([]))
        this.permiso_notariado = [{acreditacion:'', fecha:null, escritura:null, notario:''}]
      }
    }

    //ARQUITECTOS
    if(JSON.parse(localStorage.getItem("arquitectos"))){
      if (JSON.parse(localStorage.getItem("arquitectos")).length > 0){
        this.arquitectos = JSON.parse(localStorage.getItem("arquitectos"))
      }else{ 
       localStorage.setItem("arquitectos", JSON.stringify([]))
        this.arquitectos = [{rut: '', nombre:'', mail:'', apellido_mat:'', apellido_pat:'', direccion: '', direccion_complemento:'', direccion_num:'', comuna:'', fono:'', fax:'',  patente:'', recordId:''}]
      }
    }


     //LOTES ENAJENAR
     if(JSON.parse(localStorage.getItem("lotes_enajenar"))){
      if (JSON.parse(localStorage.getItem("lotes_enajenar")).length > 0){
        this.lotes_enajenar = JSON.parse(localStorage.getItem("lotes_enajenar"))
      }else{ 
       localStorage.setItem("lotes_enajenar", JSON.stringify([]))
        this.lotes_enajenar = [{lotes_enajenar:'',num_lotes:'',sup_lotes_enajenar:'', hoja_anexa:''}]
      }
     }
    
    //CARACTERISTICAS SOL
    if(JSON.parse(localStorage.getItem("caract_sol"))){
      if (JSON.parse(localStorage.getItem("caract_sol")).length > 0){
        this.caract_sol = JSON.parse(localStorage.getItem("caract_sol"))
      }else{ 
       localStorage.setItem("caract_sol", JSON.stringify([]))
        this.caract_sol = [{num_reso_perm:'',fecha_reso_perm:null, tipo_garantia:''}]
      }
    }

    //TIPO SOLICITUD DEFINITIVA URBANIZACION
    if(JSON.parse(localStorage.getItem("tipo_solicitud_def_urb"))){
      if (JSON.parse(localStorage.getItem("tipo_solicitud_def_urb")).length > 0){
        this.tipo_solicitud_def_urb = JSON.parse(localStorage.getItem("tipo_solicitud_def_urb"))
      }else{ 
       localStorage.setItem("tipo_solicitud_def_urb", JSON.stringify([]))
        this.tipo_solicitud_def_urb = [{solicitud_def_urb:''}]
      }
    }    

    //CARACTERISTICAS PROYECTO GARANTIA
    if(JSON.parse(localStorage.getItem("caract_proy_garantia"))){
      if (JSON.parse(localStorage.getItem("caract_proy_garantia")).length > 0){
        this.caract_proy_garantia = JSON.parse(localStorage.getItem("caract_proy_garantia"))
      }else{ 
       localStorage.setItem("caract_proy_garantia", JSON.stringify([]))
        this.caract_proy_garantia = [{total_predios_apro:'',total_predios_garantia:'', cambios:'',mod_aprobada:'',resolucion:'', fecha:null }]
      }
    }
    
    


  }

  captureScreen(){
    var pdf = new jspdf('p', 'mm', 'a4');

    html2canvas(document.getElementById(`page1`)).then(canvas => {
       const contentDataURL = canvas.toDataURL('image/png')
       pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });

    html2canvas(document.getElementById(`page2`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)      
    });
    html2canvas(document.getElementById(`page3`)).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png')
      pdf.addPage();
      pdf.addImage(contentDataURL, 'PNG', 5, 5, 200, 297)  
    });
    setTimeout(() =>{
      pdf.save(this.propietarios[0].rut+'.pdf')
     // pdf.save('prueba.pdf')
    },6000)
   }
}

